import { gql } from '@apollo/client';

export default gql`
  mutation archiveReadNotifications {
    archiveReadNotifications
  }
`;
